import { runElectronFunc } from './comm'
import u from "../index";

const setMenuVisibleValue = (settingJson) => {
    const electronMenuOptions = {
        ...settingJson,
        code: "MENU0001",
        userId: Often.null2Void(_USER_ID, ''),
    };
    if(window.ElectronWindowApi) runElectronFunc('ElectronWindowApi', 'visibleMenu', electronMenuOptions);
    else fn_sendValueForElectron(electronMenuOptions)
}
const focusMainBrowser = () => {
    runElectronFunc('ElectronWindowApi', 'focusMainBrowser')
}
// props: {url, title, width, height, x, y, frame}
const open = (props) => {
    runElectronFunc('ElectronWindowApi', 'open', {...props, ...{x: props.posX, y: props.posY}});
}
const openMiniMenu = (props) => {
    if(window.ElectronWindowApi) runElectronFunc('ElectronWindowApi', 'openContextMenu', props);
    else fn_openContextMenuForElectron(props.target)
}
// props: {url}
const openExternalLink = (props) => {
    const openLinkApiName = Often.isFunc("OPEN_URL_IN_CHROME") ? 'openLinkWithChrome' : 'openLink';
    const {url} = props;
    const httpRegis = /https*:\/\//i;
    const openUrl = httpRegis.test(url) ? url : ("http://" + url);

    if(window.ElectronWindowApi) runElectronFunc('ElectronWindowApi', openLinkApiName, {...props, url: openUrl});
    else fn_openExternalLinkforElectron(openUrl)
}
const openDropBox = () => {
    runElectronFunc('ElectronWindowApi', 'openDropBox', {_ROOM_SRNO:u.n2v(window._ROOM_SRNO)});
}
const setState = (props) => {
    runElectronFunc('ElectronWindowApi', 'openContextMenu', props);
}
const setMinSize = (props) => {
    try {
        if(window.ElectronWindowApi) runElectronFunc('ElectronWindowApi', 'resize', props);
        else windowMinResizeForElectron(props.width, props.height, props.mode)
    } catch (e) {
        console.error('setMinSize', '웹에서 미니를 켰습니다!');
    }
}
// props: {target, width, height, posX, posY}
const setPopupSize = (props) => {
    //  title, width, height, posX, posY
    runElectronFunc('ElectronWindowApi', 'resizePopup', props);
}
const changeProject = ({projectSrno = '', postSrno = '', remarkSrno = '', replySrno = '', homeTabCode = ''}) => {
    if (ViewChanger.isOpenProjectHomePage(projectSrno, postSrno, remarkSrno, homeTabCode)) {
        ViewChanger.loadProjectHomePage(homeTabCode, projectSrno);
        return;
    }
    if (projectSrno) ViewChanger.loadPageJson({
        code: 'detail',
        first: projectSrno,
    });
    if (postSrno) {
        PostPopup.togglePostView(projectSrno, postSrno, remarkSrno, null, true, false, replySrno);
    }
};
const openOneDrive = () => {

}
// props:  {url, title, width, height, x, y, options: {isPreload, isNotResizable}}
const openUniquePopup = (props) => {
    runElectronFunc('ElectronWindowApi', 'openUniquePopup', props);
}

export {
    setMenuVisibleValue,
    open,
    focusMainBrowser,
    openMiniMenu,
    openExternalLink,
    openDropBox,
    setState,
    setMinSize,
    setPopupSize,
    changeProject,
    openOneDrive,
    openUniquePopup
};
